import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg013DrawkitListAppColour = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1200 1200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".listapp-cls-1{fill:#dfdfdf}.listapp-cls-2{fill:#f3f3f3}.listapp-cls-3{fill:none;stroke-miterlimit:10;stroke:#f3f3f3;stroke-width:6px}.listapp-cls-5{fill:#de8e68}" }) }),
		/* @__PURE__ */ _jsxs("g", {
			id: "Backgrund",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M1005.5 142.5h137v188h-137z",
					className: "listapp-cls-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M1005.5 142.5h137v13h-137zM141 217h334v107H141z",
					className: "listapp-cls-2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 195.5,
					cy: 269.5,
					r: 35,
					className: "listapp-cls-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M254.5 236.5h196v12h-196zm0 28h66v12h-66z",
					className: "listapp-cls-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M218.89 255.42 190 284.31l-11.95-11.96",
					className: "listapp-cls-3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M141 348h334v107H141z",
					className: "listapp-cls-2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 195.5,
					cy: 400.5,
					r: 35,
					className: "listapp-cls-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M254.5 367.5h196v12h-196zm0 28h66v12h-66z",
					className: "listapp-cls-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M218.89 386.42 190 415.31l-11.95-11.96",
					className: "listapp-cls-3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M141 479h334v107H141z",
					className: "listapp-cls-2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 195.5,
					cy: 531.5,
					r: 35,
					className: "listapp-cls-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M254.5 498.5h196v12h-196zm0 28h66v12h-66z",
					className: "listapp-cls-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M218.89 517.42 190 546.3l-11.95-11.95",
					className: "listapp-cls-3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M978.5 173.5h137v188h-137z",
					className: "listapp-cls-2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M978.5 173.5h137v13h-137zm15 36h108v9h-108zm0 18h108v9h-108zm0 18h108v9h-108z",
					className: "listapp-cls-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M752.5 429.5c0-10 18-26 49-26 38 0 90 81 148 81 40 0 95-33 95-93",
					style: {
						fill: "none",
						strokeMiterlimit: 10,
						stroke: "#dfdfdf",
						strokeWidth: 11,
						strokeDasharray: 22
					}
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M454 527c-2 7-34 176 21 333 9 2 8-23 8-23l-10-215 5-81Z",
			className: "listapp-cls-5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M604 1156h-97s-33-341-33-348c6 6 5 8 30 15 15 16 121 282 121 282Z",
			style: { fill: "#56cad8" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M555.81 400c46.73 13.37 9.83 156.11-7.47 168.07s-98.4-21.7-104.94-36.84S489.65 381.07 555.81 400",
			style: { fill: "#fcc486" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M598 362c149 0 152 428 131 446s-236 35-255 0-38-446 124-446",
			style: { fill: "#fed385" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M652 391c39-29 130 87 129 108s-77 65-93 61-91.22-127.94-36-169",
			style: { fill: "#fed892" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M767 503c37 61 47 142 47 156 0 38-19 57-31 57-48 0-206-122-217-132s21-40 26-35 62 41 145 77c-12-15-47-60-48-74s78-49 78-49",
			className: "listapp-cls-5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M489.71 477.92h63.18v108.3h-63.18z",
			style: { fill: "#333" },
			transform: "rotate(-8.58 521.2 531.96)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 557.5,
			cy: 553,
			className: "listapp-cls-5",
			rx: 27,
			ry: 37.5,
			transform: "rotate(-60 557.5 553)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M624 381c0 13-52 14-52 0v-79h52Z",
			style: { fill: "#d37c59" }
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 584.5,
			cy: 257.5,
			className: "listapp-cls-5",
			rx: 51.5,
			ry: 91.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 632.5,
			cy: 270.5,
			r: 13.5,
			className: "listapp-cls-5"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M808 153c-39 0-71 28-113 28-30 0-59-36-101-36-54 0-71 29-71 49 0 16 10 34 13 34 0-5 6-23 8-25 2 7 44 56 81 56v.28a13.5 13.5 0 1 1 0 22.44V311h10c13 0 19-5 39-5 35 0 84 43 144 43 65 0 92-49 92-104 0-73-69-92-102-92" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M729 808v348H604L503.88 822.77C539 829 672 834 729 808",
			style: { fill: "#74d5de" }
		})
	]
});
export default Svg013DrawkitListAppColour;
